import React, { useContext } from 'react';
import { Link } from 'gatsby';
import LangContext from 'lib/langContext';

import {
    Header as ShellHeader,
    HeaderMenuButton,
    SkipToContent,
    HeaderGlobalBar,
    HeaderNavigation,
} from '@carbon/react';
import { useNavContext } from 'src/util/context/NavContext';

import { GlobalSearch } from './GlobalSearch';
import * as css from './Header.module.scss';
import cn from 'clsx';

export type HeaderProps = {
    contentLeft: ReactNode;
    contentRight: ReactNode;
    className?: string;
};
export function Header({ contentLeft, contentRight, className }: HeaderProps) {
    const { leftNavIsOpen, toggleNavState, searchIsOpen } = useNavContext();
    const lng = useContext(LangContext);

    return (
        <ShellHeader aria-label="Header" className={cn(css.header, className)}>
            <SkipToContent href="#main-content" className={css.skipToContent} />
            <HeaderMenuButton
                className={cn(`cds--header__action--menu`, css.headerButton)}
                aria-label="Open menu"
                onClick={() => {
                    toggleNavState('leftNavIsOpen');
                    toggleNavState('switcherIsOpen', 'close');
                }}
                isActive={leftNavIsOpen}
            />
            <Link
                className={cn(css.headerName, searchIsOpen && css.searchIsOpenOnLink)}
                to={`/${lng.current.key}/`}
                children={contentLeft}
            />

            <HeaderGlobalBar className={cn(searchIsOpen && css.searchIsOpenOnBar)}>
                <HeaderNavigation aria-label="profile menu" className={css.rightNav}>
                    <GlobalSearch />
                    {contentRight}
                </HeaderNavigation>
            </HeaderGlobalBar>
        </ShellHeader>
    );
}
